import React from "react";
import { GridColumn, GridRow, LabeledText, Stack } from "sprint-common-web";

import { ensureMovieContentDetails } from "../../../../../common/types/ContentDetails";
import { ContentSubtype } from "../../../../../common/types/ContentSubtype";
import { OnPremAssetDetails } from "../../OnPremAssetDetails";
import { OnPremMovieVersionInfo } from "./OnPremMovieVersionInfo";

type OnPremMovieContentSectionProps = {
    assetDetails: OnPremAssetDetails;
};

export const OnPremMovieContentSection: React.FunctionComponent<OnPremMovieContentSectionProps> = ({
    assetDetails
}) => {
    ensureMovieContentDetails(assetDetails.content);

    return (
        <Stack>
            <GridRow>
                <GridColumn sm={6}>
                    <LabeledText
                        label="Title"
                        value={assetDetails.content.movie.name}
                        testId="movie-name-field"
                        textTooltip
                    />
                    <LabeledText
                        label="Content type"
                        value={ContentSubtype[assetDetails.content.subtype]}
                        testId="movie-content-type-field"
                    />
                </GridColumn>
                <GridColumn sm={6}>
                    <OnPremMovieVersionInfo
                        movieId={assetDetails.content.movie.id}
                        versionIds={assetDetails.content.versionSummary.ids}
                    />
                </GridColumn>
            </GridRow>
        </Stack>
    );
};
